import { mapState } from 'vuex';

export default {
    name: 'WithGroupAccess',
    props: {
        allowed: {
            type: String,
            required: true
        }
    },

    computed: {
        ...mapState({
            groups: state => state.auth.user.groups
        }),

        allowedObject() {
            let object = {};
            this.allowed.split(',').forEach(group => {
                object[group.trim()] = true;
            });
            return object;
        },

        hasPermission() {
            if (!this.groups) return false;

            return this.groups.some(group => !!this.allowedObject[group]);
        }
    },

    render() {
        if (this.hasPermission) {
            return this.$slots.default && this.$slots.default();
        }

        return null;
    }
};
